import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { StockFee } from "../types";

export const updateStockFeeApi = (userId: string, stfee: StockFee) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "clearing/updstockfee",
    params: {
      userId,
    },
    data: stfee,
  });

export default updateStockFeeApi;
